<!-- Card filter Starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <!-- <div class="card-header">
          <h5>Fraud imports</h5><span>import fraud data</span>
        </div> -->
        <div class="card-body">
          <div class="row btn-showcase">
            <div class="col-lg-2 col-md-3 col-12">
              <div class="form-group">
                <div class="form-group">
                  <label class="form-label">Advertiser</label>
                  <ng-multiselect-dropdown
                  [placeholder]="'-- advertiser --'"
                  [settings]="dropdownSettingsAdvertiser"
                  [data]="dropdownListAdvertiser"
                  [(ngModel)]="selectedItemsAdvertiser"
                  (onSelect)="onItemSelectAdvertiser($event)"
                  (onDeSelect)="onItemDeSelectType($event)"
                  >
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <label class="form-label">Conversion ID</label>
                <input class="form-control" type="text" placeholder="conversion ID.." [(ngModel)]="importFraud.clickTrackingIdHash">
              </div>
            </div>

          </div>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="import fraud data" (click)="onImport()">
              Import</button>
        </div>
      </div>
    </div>
  </div>
<!-- Card filter Ends-->

<!-- Card table imported Starts-->
  <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
          <div class="card">
            <div class="card-body custom-datatable">
                <ngx-datatable
                class='bootstrap'
                [rows]="fraudimportData"
                [columnMode]="ColumnMode.force"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [offset]="page.pageNumber"
                [limit]="page.size"
                [count]="page.totalElements"
                [externalPaging]="true"
                (page)="setPage($event)"
              >
                <ngx-datatable-column name="firstName" prop="publisher.lastName">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Publisher</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.publisher.firstName }} {{row.publisher.lastName}}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="conversionHashId">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Conversion ID</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.conversionHashId }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="conversionReverted">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Conversion reverted</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a href="adm/offers/{{ row.offerId }}">{{ row.offerName }}</a>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="revertedRevenue">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Reenue reverted</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.revertedRevenue | currency }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="advertiserName">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a href="adm/advertisers">{{ row.advertiserName }}</a>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="date">
                  <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                    <span class="myHeader txt-primary" (click)="sort()">Import date</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.importDate | date:'d/M/yyyy H:mm'}}
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- Card table imported Ends-->
